import dateTime from './dateTime'

export default {
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  terms: 'Terms',
  privacy: 'Privacy',
  // TODO Write test
  lastModified: ds => {
    const d = new Date(ds)
    return `Last revision: ${dateTime.mmmDdYyyy(d)}`
  }
}
